import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)

const routes = [
  {
    path: '/',
    redirect: flag instanceof Array ? '/mb_home' : "/home",
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'meta.home'
    }
  },
  {
    path: '/mb_home',
    component: () => import('@/views/Mobile/home.vue'),
    meta: {
      title: 'meta.home'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/AboutView.vue'),
    meta: {
      title: 'meta.about'
    }
  },
  {
    path: '/mb_about',
    component: () => import('@/views/Mobile/aboutUs.vue'),
    meta: {
      title: 'meta.about'
    }
  },
  {
    path: '/technology',
    name: 'technology',
    component: () => import('@/views/TechnologyView.vue'),
    meta: {
      title: 'meta.technology'
    }
  },
  {
    path: '/mb_technology',
    component: () => import('@/views/Mobile/technology.vue'),
    meta: {
      title: 'meta.technology'
    }
  },
  {
    path: '/oem',
    name: 'oem',
    component: () => import('@/views/OemView.vue'),
    meta: {
      title: 'meta.oem'
    }
  },
  {
    path: '/mb_oem',
    component: () => import('@/views/Mobile/oem.vue'),
    meta: {
      title: 'meta.oem'
    }
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('@/views/ProductsView.vue'),
    meta: {
      title: 'meta.products'
    }
  },
  {
    path: '/products_gmi',
    name: 'products_gmi',
    component: () => import('@/views/ProductsGmiView.vue'),
    meta: {
      title: 'meta.gmi'
    }
  },
  {
    path: '/products_salacia',
    name: 'products_salacia',
    component: () => import('@/views/ProductsSalaciaView.vue'),
    meta: {
      title: 'Salacia Plus Tablets | SEIKA PHARMA | 诚科医药'
    }
  },
  {    
    path: '/mb_products',
    component: () => import('@/views/Mobile/products.vue'),
    meta: {
      title: 'meta.products'
    }
  },
  {
    path: '/mb_products_gmi',
    component: () => import('@/views/Mobile/productsGmiView.vue'),
    meta: {
      title: 'meta.gmi'
    }
  },
  {
    path: '/mb_products_salacia',
    component: () => import('@/views/Mobile/productsSalaciaView.vue'),
  },
  {    
    path: '/contacts',
    name: 'contacts',
    component: () => import('@/views/ContactsView.vue'),
    meta: {
      title: 'meta.contacts'
    }
  },
  {
    path: '/mb_contacts',
    component: () => import('@/views/Mobile/contacts.vue'),
    meta: {
      title: 'meta.contacts'
    }
  },
  {
    path: '/platform',
    name: 'platform',
    component: () => import('@/views/platformView.vue'),
    meta: {
      title: 'meta.platform'
    }
  },
  {
    path: '/mb_platform',
    component: () => import('@/views/Mobile/platform.vue'),
    meta: {
      title: 'meta.platform'
    }
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('@/views/serviceView.vue'),
    meta: {
      title: 'meta.services'
    }
  },
  {
    path: '/populariz',
    name: 'populariz',
    component: () => import('@/views/popularizeView.vue'),
    meta: {
      title: 'meta.popularize'
    }
  },
  {
    path: '/mb_populariz',
    component: () => import('@/views/Mobile/populariz.vue'),
    meta: {
      title: 'meta.popularize'
    }
  },
  {
    path: '/expansion',
    name: 'expansion',
    component: () => import('@/views/expansionView.vue'),
    meta: {
      title: 'meta.expansion'
    }
  },
  {
    path: '/mb_expansion',
    component: () => import('@/views/Mobile/expansion.vue'),
    meta: {
      title: 'meta.expansion'
    }
  },
  {
    path: '/material',
    name: 'material',
    component: () => import('@/views/materialView.vue'),
    meta: {
      title: 'meta.material'
    }
  },
  {
    path: '/mb_material',
    component: () => import('@/views/Mobile/material.vue'),
    meta: {
      title: 'meta.material'
    }
  },
  {
    path: '/flow',
    name: 'flow',
    component: () => import('@/views/flowView.vue'),
    meta: {
      title: 'meta.flow'
    }
  },
  {
    path: '/mb_flow',
    component: () => import('@/views/Mobile/flow.vue'),
    meta: {
      title: 'meta.flow'
    }
  },
  {
    path: '/business',
    name: 'business',
    component: () => import('@/views/businessView.vue'),
    meta: {
      title: 'meta.business'
    }
  },
  {
    path: '/mb_business',
    component: () => import('@/views/Mobile/business.vue'),
    meta: {
      title: 'meta.business'
    }
  },
  {
    path: '/registration',
    name: 'registration',
    component: () => import('@/views/RegistrationView.vue'),
    meta: {
      title: 'meta.registration'
    }
  },
  {
    path: '/mb_registration',
    component: () => import('@/views/Mobile/registration.vue'),
    meta: {
      title: 'meta.registration'
    }
  },
  {
    path: '/coq10',
    name: 'coq10',
    component: () => import('@/views/CoQ10View.vue'),
    meta: {
      title: 'meta.coq10'
    }
  },
  {
    path: '/mb_coq10',
    redirect: to => {
      // Preserve query parameters when redirecting
      return { path: '/coq10', query: to.query }
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/views/AdminView.vue'),
    meta: {
      title: 'Admin Dashboard'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) !== null;
  const path = to.path;

  if (path === '/') {
    next(isMobile ? '/mb_home' : '/home');
    return;
  }

  if (path === '/admin') {
    next();
    return;
  }

  if (isMobile) {
    if (!path.startsWith('/mb_')) {
      if (path === '/coq10') {
        next();
        return;
      }
      const targetPath = `/mb_${path.substring(1)}`;
      const hasMobileRoute = router.options.routes.some(route => route.path === targetPath);
      if (hasMobileRoute) {
        next({ path: targetPath, query: to.query });
        return;
      }
    }
  } else {
    if (path.startsWith('/mb_')) {
      const targetPath = `/${path.substring(4)}`;
      const hasPcRoute = router.options.routes.some(route => route.path === targetPath);
      if (hasPcRoute) {
        next({ path: targetPath, query: to.query });
        return;
      }
    }
  }

  next();
});

export default router
